import { render, staticRenderFns } from "./CallRecordingPlayerWidget.vue?vue&type=template&id=7fb7fd4c&scoped=true"
import script from "./CallRecordingPlayerWidget.vue?vue&type=script&lang=js"
export * from "./CallRecordingPlayerWidget.vue?vue&type=script&lang=js"
import style0 from "./CallRecordingPlayerWidget.vue?vue&type=style&index=0&id=7fb7fd4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb7fd4c",
  null
  
)

export default component.exports